export enum InvoiceStatusTypes {
  Active = 1,
  Invoiced = 2,
  Paid = 3,
}
